import React, { useEffect } from 'react';
import { markPaymentCompleted } from '../firebase-service';
import { stripeService } from '../services/stripe-service';

const PaymentSuccess: React.FC = () => {
  useEffect(() => {
    // Handle payment success - update Firebase record
    const handlePaymentSuccess = async () => {
      console.log('🎉 Payment success page loaded');
      console.log('🔍 Current URL:', window.location.href);
      console.log('🔍 URL search params:', window.location.search);
      console.log('🔍 URL pathname:', window.location.pathname);
      
      // Get ad ID and other parameters from URL
      const urlParams = new URLSearchParams(window.location.search);
      const adId = urlParams.get('ad_id') || localStorage.getItem('current_ad_id');
      const sessionId = urlParams.get('session_id');
      const paymentMethod = urlParams.get('payment_method');
      const paymentId = urlParams.get('payment_id'); // NOWPayments parameter
      
      console.log('🔍 URL params:', { adId, sessionId, paymentMethod, paymentId });
      console.log('🔍 All URL params:', Object.fromEntries(urlParams.entries()));
      
      // Only process if we have proper payment provider parameters
      const hasStripeParams = paymentMethod === 'stripe' && sessionId;
      const hasCryptoParams = paymentMethod === 'crypto'; // Crypto doesn't need payment_id in URL
      
      if (!hasStripeParams && !hasCryptoParams) {
        console.log('⚠️ No valid payment provider parameters found - not processing payment');
        console.log('This appears to be a direct page visit, not a payment provider redirect');
        return;
      }
      
      if (adId) {
        try {
          // Handle different payment methods
          if (paymentMethod === 'stripe' && sessionId) {
            console.log('Processing Stripe payment success');
            const isValid = await stripeService.handlePaymentSuccess(sessionId);
            if (!isValid) {
              console.error('Stripe payment verification failed');
              return;
            }
          }
          
          // Mark payment as completed (works for both Stripe and crypto)
          await markPaymentCompleted(adId);
          console.log('✅ Payment status updated to completed for ad:', adId);
        } catch (error) {
          console.error('Error updating payment status:', error);
        }
      } else {
        console.warn('⚠️ No ad ID found in URL parameters or localStorage');
        console.log('🔍 localStorage current_ad_id:', localStorage.getItem('current_ad_id'));
      }
    };

    handlePaymentSuccess();
  }, []);

  return (
    <div className="payment-result-page">
      <div className="payment-result-container success-page">
        <div className="payment-result-header">
          <div className="payment-result-icon">✅</div>
          <h1 className="payment-result-title">Payment Successful!</h1>
          <p className="payment-result-subtitle">
            Thank you for your payment. Your Neodia Telegram advertisement has been successfully purchased.
          </p>
        </div>
        
        <div className="payment-result-body">
          <div className="payment-result-details">
            <h3>What happens next?</h3>
            <ul>
              <li data-icon="📋">Your ad will be reviewed within 2 hours</li>
              <li data-icon="📢">Your ad will be posted on Neodia Telegram channel</li>
              <li data-icon="📊">You'll receive performance metrics via email</li>
              <li data-icon="🔒">Your ad will have 2-hour exclusivity slot</li>
              <li data-icon="⚡">Ad will reach 57,000+ engaged readers</li>
            </ul>
          </div>
          
          <div className="payment-result-actions">
            <button 
              className="payment-result-button"
              onClick={() => window.location.href = '/'}
            >
              <span>🚀</span>
              Create Another Ad
            </button>
          </div>
        </div>
        
        <div className="payment-result-footer">
          <p>
            Need help? Contact us <a href="https://t.me/neodia_ad" target="_blank" rel="noopener noreferrer">@neodia_ad</a> in telegram - reply in minutes
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess; 